import {formatCellValue as formatCellHelper} from "@/libs/helper/formatCellValue";
import {FaCheckCircle, FaTimesCircle} from "react-icons/fa";

export const NeoAttendance: React.FC<any> = ({data, uid}) => {
  const isPresent = formatCellHelper.formatAttendance(data[uid]);
  //console.log(isPresent);

  return (
    <>
      <div className="mt-1 flex justify-center">
        {isPresent ? (
          <FaCheckCircle className="text-green-500" size={20} />
        ) : (
          <FaTimesCircle className="text-red-500" size={20} />
        )}
        {/* <span
          className={
            isPresent
              ? "font-medium text-green-600"
              : "font-medium text-red-600"
          }
        >
          {data}
        </span> */}
      </div>
    </>
  );
};
